import * as yup from "yup";
import { isValidDateTest, maxLengthMessage } from "../../../utils/functions";

const certificationSchema = yup.object().shape({
  certificationType: yup
    .string()
    .trim()
    .max(150, maxLengthMessage(150))
    .required("Certificate Type is required")
    .nonNullable(),
  dateObtained: isValidDateTest("Obtained Date"),
  expireDate: isValidDateTest("Expiration"),
  employee: yup
    .string()
    .trim()
    .max(50, maxLengthMessage(50))
    .required("Please select an employee")
    .nonNullable(),
  fromWhom: yup.string().trim().max(150, maxLengthMessage(150)).nullable(),
  comments: yup.string().trim().nullable(),
  certificateNumber: yup
    .string()
    .trim()
    .max(100, maxLengthMessage(100))
    .required("Certificate Number is required")
    .nonNullable(),
});

export default certificationSchema;
